type ParsedRoute = {pathname: string; params: URLSearchParams};

const parseRoute = (route: string): ParsedRoute => {
  const [pathPart = '', query = ''] = route.split('?');
  const withLeadingSlash = pathPart.startsWith('/') ? pathPart : `/${pathPart}`;
  // `/kyc/` and `/kyc` are the same page.
  const pathname =
    withLeadingSlash.length > 1
      ? withLeadingSlash.replace(/\/+$/, '') || '/'
      : withLeadingSlash;
  return {pathname, params: new URLSearchParams(query)};
};

/**
 * Which submenu item the current route belongs to, or -1 for none.
 *
 * An item matches when the route's pathname equals its path or sits under it
 * (`/processors/transactions/:id` under `processors/transactions`), and every
 * query param the item names (`kyc/?status=PENDING`) has the same value in
 * the route. When several match, the longest path wins, so a section root such
 * as `processors` is only active on the root page itself, not on every sibling
 * under it. Ties go to the item naming more query params, then to the first.
 */
export const findActiveSubMenuIndex = (
  route: string,
  subMenuPaths: string[],
): number => {
  const current = parseRoute(route);
  let bestIndex = -1;
  let bestPathLength = -1;
  let bestParamCount = -1;

  subMenuPaths.forEach((path, index) => {
    const item = parseRoute(path);
    const isUnderPath =
      current.pathname === item.pathname ||
      current.pathname.startsWith(
        item.pathname === '/' ? '/' : `${item.pathname}/`,
      );
    if (!isUnderPath) {
      return;
    }
    const itemParams = [...item.params.entries()];
    if (itemParams.some(([key, value]) => current.params.get(key) !== value)) {
      return;
    }
    const isLonger = item.pathname.length > bestPathLength;
    const isSameLengthMoreParams =
      item.pathname.length === bestPathLength &&
      itemParams.length > bestParamCount;
    if (isLonger || isSameLengthMoreParams) {
      bestIndex = index;
      bestPathLength = item.pathname.length;
      bestParamCount = itemParams.length;
    }
  });

  return bestIndex;
};
